import * as theme from "./Toolbar.css";

export function ToolbarSpacer() {
    return <span className={theme.spacerTool} />;
}
